import { createAction, props } from "@ngrx/store";
import { StatementDates, StatementDocument, StatementError } from "../../interfaces";

export const postDownloadStatementData = createAction(
    `[Equipment Location Form] post Equipment Location Data`,
    props<{ statementDates: StatementDates }>()
);

export const postDownloadStatementDataSuccess = createAction(
    `[Equipment Location Form] post Equipment Location Data Success`,
    props<{ statementDocument: StatementDocument }>()
);

export const postDownloadStatementDataError = createAction(
    `[Equipment Location Form] post Equipment Location Data Error`,
    props<{ error: StatementError }>()
);

export const resetSubmittingDownloadStatementForm = createAction(
    `[Equipment Location Form] reset Equipment Location Form Data`,
);